import {
    Component,
    OnInit
} from '@angular/core';
import CONFIGURATION from '../../configurations/configuration';
import { TranslateService } from '@ngx-translate/core';
import { MetaService } from 'app/services/meta.service';

@Component({
    selector: 'not-found-page',
    templateUrl: './not-found-page.html'
})

export class NotFoundPageComponent implements OnInit {
    countryCode: string;

    constructor(private _translateService: TranslateService, private _metaService: MetaService) {
        this.countryCode = CONFIGURATION.country_code;
    }
    ngOnInit() {
      this._translateService.get('not-found-page.page-title').subscribe(
        title => {
          if (title) {
            this._metaService.setTitle(title);
          }
      });
    }

}
